import CrudCustom from '../../../libs/custom/CrudCustom';

let TransaksiReferensiPiutangService = new CrudCustom('/transaksi-referensi-piutangs');
export default TransaksiReferensiPiutangService;
